
export class PathManipulation {

    static getBasePath(appSettings: any): string {
        const name = '@pershing/nxi-ng-portal-common';
        if (appSettings.portalAppProperties) {
            const portalAppsProperties = appSettings.portalAppProperties;
            if (portalAppsProperties[name]) {
                return appSettings.cdnAttributes.cdnPath + '/' + name + '@' + portalAppsProperties[name];
            }
        }
        return null;
    }
}
